<template>
  <img
    src="../../assets/logo.png"
    alt="img"
    class="logo"
    style="height:65px !important;"
  />
</template>

<script>
export default {
  name: "SteppiLogo"
};
</script>

<style>
</style>
